// Dukungan PWA: registrasi service worker, notifikasi versi baru, dan prompt "Pasang aplikasi".
import { useSyncExternalStore } from "react";
import { toast } from "sonner";

let deferredPrompt = null;
const listeners = new Set();
const emit = () => listeners.forEach((l) => l());

export const isStandalone = () =>
  window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;

export const isIOS = () =>
  /iphone|ipad|ipod/i.test(navigator.userAgent) ||
  (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

// Dipanggil sekali dari index.js, sebelum React dirender, agar event beforeinstallprompt tidak terlewat.
export function initPwa() {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferredPrompt = e;
    emit();
  });
  window.addEventListener("appinstalled", () => {
    deferredPrompt = null;
    emit();
  });

  // Service worker hanya di build produksi (di dev server akan mengganggu hot reload).
  if (process.env.NODE_ENV !== "production" || !("serviceWorker" in navigator)) return;

  window.addEventListener("load", () => {
    const hadController = !!navigator.serviceWorker.controller;
    let reloading = false;
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      // Kunjungan pertama juga memicu controllerchange — jangan reload saat itu.
      if (!hadController || reloading) return;
      reloading = true;
      window.location.reload();
    });

    navigator.serviceWorker.register("/service-worker.js").then((reg) => {
      const promptUpdate = (worker) =>
        toast("Versi baru aplikasi tersedia", {
          duration: Infinity,
          action: { label: "Muat ulang", onClick: () => worker.postMessage("SKIP_WAITING") },
        });
      if (reg.waiting && hadController) promptUpdate(reg.waiting);
      reg.addEventListener("updatefound", () => {
        const worker = reg.installing;
        worker?.addEventListener("statechange", () => {
          if (worker.state === "installed" && navigator.serviceWorker.controller) promptUpdate(worker);
        });
      });
      // Aplikasi yang dibiarkan terbuka lama tetap mengecek versi baru tiap jam.
      setInterval(() => reg.update().catch(() => {}), 60 * 60 * 1000);
    }).catch(() => {});
  });
}

async function promptInstall() {
  if (!deferredPrompt) return false;
  deferredPrompt.prompt();
  const { outcome } = await deferredPrompt.userChoice;
  deferredPrompt = null;
  emit();
  return outcome === "accepted";
}

const subscribe = (l) => { listeners.add(l); return () => listeners.delete(l); };

// canInstall: browser mendukung prompt instal (Android/Chrome/Edge).
// iOS tidak punya prompt — tampilkan petunjuk "Bagikan → Tambah ke Layar Utama".
export function useInstallPrompt() {
  const canInstall = useSyncExternalStore(subscribe, () => !!deferredPrompt);
  const standalone = isStandalone();
  return {
    canInstall: canInstall && !standalone,
    showIOSHint: !standalone && isIOS(),
    promptInstall,
  };
}
